import {
  AdminAppAction,
  CreateEventErrorAction,
  CreateEventRequestAction,
  CreateEventSuccessAction,
  EventActionType,
  createEventError,
  createEventSuccess,
} from '../../actions';
import {
  CREATE_EVENT_MUTATION,
  CreateEventPayload,
  CreateEventVariables,
} from '../../mutations';
import { Epic, ofType } from 'redux-observable';
import { AdminAppState } from '../../state';
import { EpicDependencies } from '../epic-dependencies';
import { Observable } from 'rxjs';
import { getCreateEventInput } from '../../selectors';
import { switchMap } from 'rxjs/operators';

export const createEventEpic: Epic<
  AdminAppAction,
  CreateEventSuccessAction | CreateEventErrorAction,
  AdminAppState,
  EpicDependencies
> = (
  action$,
  state,
  { client },
): Observable<CreateEventSuccessAction | CreateEventErrorAction> =>
  action$.pipe(
    ofType<AdminAppAction, CreateEventRequestAction>(
      EventActionType.CreateEventRequest,
    ),
    switchMap(async (action: CreateEventRequestAction) => {
      const { data, errors } = await client.mutate<
        CreateEventPayload,
        CreateEventVariables
      >({
        errorPolicy: 'all',
        mutation: CREATE_EVENT_MUTATION,
        variables: {
          input: getCreateEventInput(action.eventKey)(state.value),
        },
      });

      if (errors) {
        return createEventError(action.eventKey, errors);
      } else if (data) {
        return createEventSuccess(action.eventKey);
      } else {
        throw new Error('No data.');
      }
    }),
  );
